// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2Egxn","content":"styles_content__2htNu"};